export default __webpack_public_path__ + "static/logo-full-780f7af3f377a0d2e4855615ea4545cf.svg";